// Ensures valid structure (username@domain.tld)
export const validateEmail = (email) => {
  if (!email) return false;
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email.trim());
};
// Indian standard: 10 digits, starting with (6/7/8/9)
export const validatePhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return false;
  const phoneRegex = /^[6-9]\d{9}$/;
  return phoneRegex.test(phoneNumber.trim());
};

// Name validation (first/last name → alphabets only, allows spaces, no special chars/numbers)
export const validateName = (name) => {
  if (!name) return false;
  const regex = /^[A-Za-z]+(?: [A-Za-z]+)*$/;
  return regex.test(name.trim());
};

// Validate branch or college names (// Allows A-Z, 0-9, space, - / ( ) . ')
export const validateCollegeName = (value) => {
  if (!value) return false;
  const regex = /^[A-Za-z0-9\s.\-()']+$/;
  return regex.test(value.trim());
};

// Allows letters, spaces, &, and -
export const validateBranchName = (branchName) => {
  if (!branchName) return false;
  const regex = /^[A-Za-z\s&-]+$/;
  return regex.test(branchName.trim());
};
